// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2PpHH","containerItemsCenter":"Skeleton_containerItemsCenter__1pdrG"};